import { SubcategoryDetailProps } from "../constants/settingsStructure";
import LegacySettingsRedirect from "../components/LegacySettingsRedirect";

const CompanyCamDetail = ({ subcategory, categoryId }: SubcategoryDetailProps) => {
  return (
    <LegacySettingsRedirect
      title={subcategory.label}
      description="Configure your Company Cam integration for photo synchronization and project management."
      categoryId={categoryId}
    />
  );
};

export default CompanyCamDetail;
